import { graphql } from 'relay-runtime';

export const DataValidationRulesLibraryQuery = graphql`
  query dataValidationRulesLibraryQuery(
    $owner: String
    $connectorComponentRef: ConnectorComponentRefInput!
  ) {
    validationRulesLibrary(
      owner: $owner
      connectorComponentRef: $connectorComponentRef
    ) {
      resourceName
      displayName
      provider
      description
      categories
      datastoreId
      status
      statusMessage
      containerId
      datastoreId
      checkId
      tableRef
      ruleLibraryItemRef {
        rliType
      }
    }
  }
`.default;
